<div class="condition">
  <span class="condition__text">
     {{condition.data.linkText}}
  </span>
 </div>
